import { useQuery } from "@tanstack/react-query";
import { Container } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import ArchiveDocumentList from "@/components/DocumentList/ArchiveDocumentList";
import { useCaseApi } from "@/hooks/useApi";
import { useAuth } from "@/hooks/useAuth";
import { caseGetOptions } from "@/lib/query-options";

interface CaseArchiveParams {
  id: string;
}

export default function CaseArchiveListScreen() {
  const params = useParams<CaseArchiveParams>();
  const caseApi = useCaseApi();
  const authResult = useAuth();

  const caseQuery = useQuery(
    caseGetOptions(caseApi, authResult.user?.firmId ?? "", params.id),
  );

  const caseTitle =
    caseQuery.data?.shortTitle ?? caseQuery.data?.title ?? "Case";

  return (
    <Container className="pt-3">
      <p>
        <Link to="/cases">Cases</Link>
        {" > "}
        <Link to={`/cases/${params.id}`}>{caseTitle}</Link>
        {" > "}
        Archived
      </p>
      <header className="d-flex justify-content-between mb-3">
        <h1>Archived Documents</h1>
      </header>
      <div>
        <ArchiveDocumentList caseId={params.id} />
      </div>
    </Container>
  );
}
